export const MOTION = {
  ease: 'power3.out',
  durationSm: 0.4,
  durationMd: 0.7,
  durationLg: 1.0,
  staggerLines: 0.06,
  y: 24,
  yPercent: 100,
};
